import React from 'react';
import Link from '@/links';
import {Grid as BaseGrid} from '@/grid';
import ModalButton from '@/ui/modal-button';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';

export type FeatureItem = {
  title: string;
  copy?: string;
  richCopy?: string;
  pill?: boolean;
};

type FeatureSectionMessages = {
  title: string;
  features: FeatureItem[];
};

/** Read a feature list from a section object — avoids t.raw('section.features') under the features.* namespace. */
export function getSectionFeatures(
  t: {raw: (key: string) => unknown},
  sectionKey: string
): FeatureItem[] {
  const section = t.raw(sectionKey) as FeatureSectionMessages;
  return Array.isArray(section?.features) ? section.features : [];
}

export const workableAgentLink = (chunks: React.ReactNode) => (
  <Link href="/workable-ai" variant="highlighted-underlined">
    {chunks}
  </Link>
);

type DivProps = React.HTMLAttributes<HTMLDivElement>;

type DivComponent = (props: DivProps) => React.ReactElement;

export const DivMargined = withMarginBottomDoubleXlToXl(
  'div' as unknown as DivComponent
) as DivComponent;

/** Grid forwards `children` via createProps; PropTypes-only export omits it from types. */
export const Grid = BaseGrid as React.ComponentType<{
  fluid?: boolean;
  className?: string;
  tagName?: string;
  children?: React.ReactNode;
}>;

export type ModalButtonProps = React.ComponentProps<typeof ModalButton> & {
  openName?: string;
  videoId: string;
  variant?: string;
  ariaLabel?: string;
  customAttributes?: Record<string, string>;
  transcript?: string;
};

export const VideoModalButton = ModalButton as React.ForwardRefExoticComponent<
  ModalButtonProps & React.RefAttributes<HTMLButtonElement>
>;
